import React from 'react';
import { NavLink } from 'react-router-dom';

export class NavMenu extends React.Component {
    render() {
        return <nav className='navbar navbar-expand-lg navbar-light bg-light'>
            <NavLink to={'/'} className='navbar-brand' href='/'>Silvermouse</NavLink>
            <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarText' aria-controls='navbarText' aria-expanded='false' aria-label='Toggle navigation'>
                <span className='navbar-toggler-icon'></span>
            </button>
            <div className='collapse navbar-collapse' id='navbarText'>
                <ul className='navbar-nav mr-auto'>
                    <li className='nav-item'>
                        <NavLink to={'/NonLinearForm/0'} className='nav-link' activeClassName='active'>
                            <span className='glyphicon glyphicon-education'></span> BBC Non-Linear
                            </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink to={'/DeletedCues/0'} className='nav-link' activeClassName='active'>
                            <span className='glyphicon glyphicon-education'></span> View Deleted Cues
                            </NavLink>
                    </li>
                </ul>
                <span className='navbar-text'>Login User Informations or Menu</span>
            </div>
        </nav>;
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js